/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Deduct_On_Delivery_DescInputs */

const vi_packaging_material_deduct_on_delivery_desc = /** @type {(inputs: Packaging_Material_Deduct_On_Delivery_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Túi giao, băng dính — thứ đi kèm lúc gửi đơn.`)
};

/**

* @param {Packaging_Material_Deduct_On_Delivery_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_deduct_on_delivery_desc = /** @type {((inputs?: Packaging_Material_Deduct_On_Delivery_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Deduct_On_Delivery_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_deduct_on_delivery_desc(inputs)
});